import api from '@/api';
import { ApiError } from '@/utils/shared/api.error';
import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../use-auth';
import { useNavigate } from 'react-router-dom';
import { paths } from '@/config/paths';

type TData = void;
type TError = ApiError;
type TVariables = void;
type TContext = {};

export function useRevokeSessionMutation(options?: UseMutationOptions<TData, TError, TVariables, TContext>) {
  const { logout } = useAuth();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation<TData, TError, TVariables, TContext>({
    mutationKey: ['revoke-session'],
    mutationFn: api.auth.session.revoke,
    onSuccess: () => {
      logout();
      queryClient.clear();
      navigate(paths.auth.login.getHref());
    },
    ...options,
  });
}
